import React, { useState } from "react";
import LinkingModal from "./LinkingModal";
import FieldDisabled from "../../components/SimpleForm/FieldDisabled";
import setFieldValues9142B from "./setFieldValues9142B";

const RegistrationNumberLinking = ({
  schemaProps: {
    linkingSchema: {
      formId,
      modalScreens,
      allowOutOfNetwork,
      sortingFields,
      rnLinkingDataField,
    },
    machine_name,
    disabled,
    disableWhenField,
    toEnable,
  },
  formValues,
  formApi,
}) => {
  const isDisabled = FieldDisabled(disabled, disableWhenField, formApi);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const registrationNumber = formValues[machine_name];

  return (
    <div>
      {isDisabled && (
        <>
          <div class="usa-alert usa-alert--info usa-alert--slim">
            <div class="usa-alert__body">
              <p class="usa-alert__text">{toEnable}</p>
            </div>
          </div>
          <br></br>
        </>
      )}
      {!registrationNumber && (
        <button
          onClick={() => setIsModalOpen(!isModalOpen)}
          type="button"
          className="usa-button usa-button--outline"
          disabled={isDisabled}
        >
          Registration Number Lookup
        </button>
      )}
      {!!registrationNumber && (
        <div style={{ marginTop: "1rem" }}>
          <span className="usa-tag">Registration Number</span>
          <strong> {registrationNumber} </strong>{" "}
          <span
            tabIndex={0}
            onClick={() =>
              setFieldValues9142B({
                formApi,
                machine_name,
                selectedRegistrationNumber: null,
                rnLinkingDataField,
                isPrefill: false,
                formMsaValue: null,
              })
            }
            className="button-link"
            style={{ marginLeft: "1rem" }}
          >
            Clear
          </span>
        </div>
      )}
      <LinkingModal
        open={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        modalScreens={modalScreens}
        allowOutOfNetwork={allowOutOfNetwork}
        formId={formId}
        machine_name={machine_name}
        formApi={formApi}
        sortingFields={sortingFields}
        rnLinkingDataField={rnLinkingDataField}
      />
    </div>
  );
};

export default RegistrationNumberLinking;
